import IntlService from 'ember-intl/services/intl';
import enTranslations from '../../translations/en.json';
import esTranslations from '../../translations/es.json';

export default class MyIntlService extends IntlService {
  constructor() {
    super(...arguments);
    // Load translations directly
    this.addTranslations('en', enTranslations);
    this.addTranslations('es', esTranslations);
  }
}

